import { AdjacentType } from '@iotv/iotv-v3-types'

import { BranchingQueryDefinition } from '../util'
import { getParentEdgeTypeId } from '../classDependentTypes'

export const getSimpleBranchingQuery = (
  sourceType: string,
  targetType: string,
  adjacencyType: AdjacentType,
  id: string | undefined = undefined,
): BranchingQueryDefinition => {
  return new BranchingQueryDefinition({
    id: id ?? `${sourceType}to${targetType}Query`,
    path: [
      {
        objectTypeId: targetType,
        adjacencyType,
        edgeTypeId: adjacencyType == AdjacentType.CHILD ? getParentEdgeTypeId(targetType, sourceType) : getParentEdgeTypeId(sourceType, targetType),
      },
    ],
    subQueries: [],
  })
}
